import React from 'react';
import { graphql } from 'gatsby';

import Container from '@/components/Container';
import BlockWrapper from '@/components/BlockWrapper';
import RichText, { RichTextType } from '@/components/Richtext';
import { isDarkTheme } from '@/utils/StyleUtils';

export type RichTextBlockType = RichTextType & {
  id: string;
  __typename?: string;
  contentful_id?: string;
  backgroundColor: string;
  noContainer?: boolean;
};
type Props = RichTextBlockType;
const RichTextBlock: React.FC<Props> = (props) => {
  const richText = (
    <RichText
      data={props.richText}
      defaultPaths={props.defaultPaths}
      options={{
        theme: isDarkTheme(props.backgroundColor) ? 'dark' : 'white',
      }}
    />
  );
  return (
    <BlockWrapper
      id={props.id}
      color={props.backgroundColor}
      padding={props.noContainer ? 'xsmall' : 'large'}
    >
      {props.noContainer && richText}
      {!props.noContainer && <Container narrow={true}>{richText}</Container>}
    </BlockWrapper>
  );
};

export default RichTextBlock;
export const singleLargeImageBlockFragmentQuery = graphql`
  fragment RichTextBlockFragment on ContentfulRichTextBlock {
    id
    __typename
    richText {
      ...RichTextFragment
    }
    backgroundColor
  }
`;
